import React from "react";
import styled  from "styled-components";

// todo - add more spinner color once design system is integrated
const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #80CBC4;
  width: 80px;
  height: 80px;
  text-align: center;
    margin: 0 auto;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin-top:20%;

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const FullPageLoader = (props) => <Spinner {...props} />;

FullPageLoader.defaultProps = {
    color: "white",
};

export default FullPageLoader;
